import { Directive, Input, OnDestroy, OnInit, Host, Self } from '@angular/core';
import { VideoViewerComponent } from '../components/video-viewer/video-viewer.component';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

export interface VideoROIOverlay {
  id: string;
  x: number;
  y: number;
  w: number;
  h: number;
  t1: number;
  t2: number;
  selected: boolean;
  color?: string;
  tooltip?: string;
}

export interface IVideoROIFrame {
  id: string;
  x: number;
  y: number;
  w: number;
  h: number;
  t1: number;
  t2: number;
  selected: boolean;
  analysisId: string;
  findingId: string;
  labels: { [key: string]: number };
}
@Directive({
    selector: '[tsVideoRoisViewer]',
    standalone: false
})
export class VideoRoisViewerDirective implements OnInit, OnDestroy {
  @Input() videoOverlays: VideoROIOverlay[] = [];
  private destroy$ = new Subject<void>();

  constructor(@Host() @Self() protected viewerComponent: VideoViewerComponent) {}

  ngOnInit(): void {
    this.viewerComponent.frameDrawn$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.renderROIs();
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private renderROIs(): void {
    const ctx = this.viewerComponent.ctx;
    if (!ctx) return;

    const currentTime = this.viewerComponent.videoCurrentTime;

    this.videoOverlays
      .filter((roi) => currentTime >= roi.t1 && currentTime <= roi.t2)
      .forEach((roi) => {
        ctx.strokeStyle = roi.color;
        ctx.strokeRect(roi.x, roi.y, roi.w - 1, roi.h - 1);
        ctx.stroke();
      });
  }
}
